import { Routes } from "@angular/router";
// Third party packages
// Custom packages
import { AdminQRCodeMappingComponent } from "src/app/components/adminQRCodeMapping/adminQRCodeMapping.component";
import { PrivacyDocsPublicAccessComponent } from "src/app/components/privacyDocsPublicAccess/privacyDocsPublicAccess.component";
import { SupplierSecurityVideoComponent } from "src/app/components/supplierSecurityVideo/supplierSecurityVideo.component";
import { AuthGuard } from "src/app/shared/guards/auth.guard";
import { LangGuard } from "src/app/shared/guards/lang.guard";
import { AppWrapperComponent } from "./components/app-wrapper/app-wrapper.component";
import { HomeComponent } from "./components/home/home.component";
import { PublicQRCodeComponent } from "./components/publicQRCode/publicQRCode.component";
import { PublicQrV3LegacyGuard } from "src/app/shared/guards/public-qr-v3-legacy.guard";
var ɵ0 = { qrKind: "document" }, ɵ1 = function () {
    return import("./modules/public-qr-v3/public-qr-v3.module.ngfactory").then(function (m) { return m.PublicQrV3ModuleNgFactory; });
}, ɵ2 = { qrKind: "area" }, ɵ3 = function () {
    return import("./modules/public-qr-v3/public-qr-v3.module.ngfactory").then(function (m) { return m.PublicQrV3ModuleNgFactory; });
}, ɵ4 = { qrKind: "section" }, ɵ5 = function () {
    return import("./modules/public-qr-v3/public-qr-v3.module.ngfactory").then(function (m) { return m.PublicQrV3ModuleNgFactory; });
}, ɵ6 = { qrKind: "section" }, ɵ7 = function () {
    return import("./modules/public-qr-v3/public-qr-v3.module.ngfactory").then(function (m) { return m.PublicQrV3ModuleNgFactory; });
}, ɵ8 = { qrKind: "legacyDoc" }, ɵ9 = function () {
    return import("./modules/public-qr-v3/public-qr-v3.module.ngfactory").then(function (m) { return m.PublicQrV3ModuleNgFactory; });
}, ɵ10 = { qrKind: "legacySection" }, ɵ11 = function () {
    return import("./modules/public-qr-v3/public-qr-v3.module.ngfactory").then(function (m) { return m.PublicQrV3ModuleNgFactory; });
}, ɵ12 = { qrKind: "legacySection" }, ɵ13 = function () {
    return import("./modules/public-qr-v3/public-qr-v3.module.ngfactory").then(function (m) { return m.PublicQrV3ModuleNgFactory; });
}, ɵ14 = { qrKind: "legacySection" }, ɵ15 = function () {
    return import("./modules/public-qr-v3/public-qr-v3.module.ngfactory").then(function (m) { return m.PublicQrV3ModuleNgFactory; });
}, ɵ16 = { qrKind: "legacySectionold" }, ɵ17 = function () {
    return import("./modules/public-qr-v3/public-qr-v3.module.ngfactory").then(function (m) { return m.PublicQrV3ModuleNgFactory; });
}, ɵ18 = { publicQrLegacy: "sectionold" }, ɵ19 = { publicQrLegacy: "section" }, ɵ20 = { publicQrLegacy: "section" }, ɵ21 = { publicQrLegacy: "section" }, ɵ22 = { publicQrLegacy: "doc" }, ɵ23 = { docType: "condo-owner" }, ɵ24 = { docType: "supplier" }, ɵ25 = { docType: "supplier" }, ɵ26 = function () {
    return import("./modules/auth/auth.module.ngfactory").then(function (m) { return m.AuthModuleNgFactory; });
}, ɵ27 = function () {
    return import("./modules/users/users.module.ngfactory").then(function (m) { return m.UsersModuleNgFactory; });
}, ɵ28 = function () {
    return import("./modules/temporaries/temporaries.module.ngfactory").then(function (m) { return m.TemporariesModuleNgFactory; });
}, ɵ29 = function () {
    return import("./modules/permissions/permissions.module.ngfactory").then(function (m) { return m.PermissionsModuleNgFactory; });
}, ɵ30 = function () {
    return import("./modules/roles/roles.module.ngfactory").then(function (m) { return m.RolesModuleNgFactory; });
}, ɵ31 = function () {
    return import("./modules/companies/companies.module.ngfactory").then(function (m) { return m.CompaniesModuleNgFactory; });
}, ɵ32 = function () {
    return import("./modules/suppliers/suppliers.module.ngfactory").then(function (m) { return m.SuppliersModuleNgFactory; });
}, ɵ33 = function () {
    return import("./modules/properties/properties.module.ngfactory").then(function (m) { return m.PropertiesModuleNgFactory; });
}, ɵ34 = function () {
    return import("./modules/services/services.module.ngfactory").then(function (m) { return m.ServicesModuleNgFactory; });
}, ɵ35 = function () {
    return import("./modules/prices/prices.module.ngfactory").then(function (m) { return m.PricesModuleNgFactory; });
}, ɵ36 = function () {
    return import("./modules/subscriptions/subscriptions.module.ngfactory").then(function (m) { return m.SubscriptionsModuleNgFactory; });
}, ɵ37 = function () {
    return import("./modules/communications/communications.module.ngfactory").then(function (m) { return m.CommunicationsModuleNgFactory; });
}, ɵ38 = function () {
    return import("./modules/balances/balances.module.ngfactory").then(function (m) { return m.BalancesModuleNgFactory; });
}, ɵ39 = function () {
    return import("./modules/access-logs/access-logs.module.ngfactory").then(function (m) { return m.AccessLogsModuleNgFactory; });
}, ɵ40 = function () {
    return import("./modules/deadlines/deadlines.module.ngfactory").then(function (m) { return m.DeadlinesModuleNgFactory; });
}, ɵ41 = function () {
    return import("./modules/groundings/groundings.module.ngfactory").then(function (m) { return m.GroundingsModuleNgFactory; });
}, ɵ42 = function () {
    return import("./modules/caretakers/caretakers.module.ngfactory").then(function (m) { return m.CaretakersModuleNgFactory; });
}, ɵ43 = function () {
    return import("./modules/summary-docs/summary-docs.module.ngfactory").then(function (m) { return m.SummaryDocsModuleNgFactory; });
}, ɵ44 = function () {
    return import("./modules/tank/tank.module.ngfactory").then(function (m) { return m.TankModuleNgFactory; });
}, ɵ45 = function () {
    return import("./modules/historical-docs/historical-docs.module.ngfactory").then(function (m) { return m.HistoricalDocsModuleNgFactory; });
}, ɵ46 = function () {
    return import("./modules/search-docs/search-docs.module.ngfactory").then(function (m) { return m.SearchDocsModuleNgFactory; });
}, ɵ47 = function () {
    return import("./modules/add-documents/add-documents.module.ngfactory").then(function (m) { return m.AddDocumentsModuleNgFactory; });
}, ɵ48 = function () {
    return import("./modules/add-documents-v3/add-documents-v3.module.ngfactory").then(function (m) { return m.AddDocumentsV3ModuleNgFactory; });
}, ɵ49 = function () {
    return import("./modules/ddts/ddts.module.ngfactory").then(function (m) { return m.DdtsModuleNgFactory; });
}, ɵ50 = function () {
    return import("./modules/stats/stats.module.ngfactory").then(function (m) { return m.StatsModuleNgFactory; });
}, ɵ51 = function () {
    return import("./modules/settings/settings.module.ngfactory").then(function (m) { return m.SettingsModuleNgFactory; });
}, ɵ52 = function () {
    return import("./modules/interventions/interventions.module.ngfactory").then(function (m) { return m.InterventionsModuleNgFactory; });
}, ɵ53 = function () {
    return import("./modules/electric-meters/electric-meters.module.ngfactory").then(function (m) { return m.ElectricMetersModuleNgFactory; });
}, ɵ54 = function () {
    return import("./modules/gas-meters/gas-meters.module.ngfactory").then(function (m) { return m.GasMetersModuleNgFactory; });
}, ɵ55 = function () {
    return import("./modules/water-meters/water-meters.module.ngfactory").then(function (m) { return m.WaterMetersModuleNgFactory; });
}, ɵ56 = function () {
    return import("./modules/personal-data/personal-data.module.ngfactory").then(function (m) { return m.PersonalDataModuleNgFactory; });
}, ɵ57 = function () {
    return import("./modules/generic-docs/generic-docs.module.ngfactory").then(function (m) { return m.GenericDocsModuleNgFactory; });
}, ɵ58 = function () {
    return import("./modules/deleted-docs/deleted-docs.module.ngfactory").then(function (m) { return m.DeletedDocsModuleNgFactory; });
}, ɵ59 = function () {
    return import("./modules/summary-docs-v3/summary-docs-v3.module.ngfactory").then(function (m) { return m.SummaryDocsV3ModuleNgFactory; });
}, ɵ60 = function () {
    return import("./modules/deleted-docs-v3/deleted-docs-v3.module.ngfactory").then(function (m) { return m.DeletedDocsV3ModuleNgFactory; });
}, ɵ61 = function () {
    return import("./modules/deadlines-v3/deadlines-v3.module.ngfactory").then(function (m) { return m.DeadlinesV3ModuleNgFactory; });
}, ɵ62 = function () {
    return import("./modules/historical-docs-v3/historical-docs-v3.module.ngfactory").then(function (m) { return m.HistoricalDocsV3ModuleNgFactory; });
}, ɵ63 = function () {
    return import("./modules/arturo/arturo.module.ngfactory").then(function (m) { return m.ArturoModuleNgFactory; });
}, ɵ64 = function () {
    return import("./modules/errors/errors.module.ngfactory").then(function (m) { return m.ErrorsModuleNgFactory; });
};
// Define routes
var routes = [
    { path: "supplier-security-video/:supplierId", pathMatch: "prefix", component: SupplierSecurityVideoComponent },
    // Public QR page of the new archive (NEW-A3 FE). FIRST, before the legacy `qrcode/...` routes:
    // their last one takes any five segments, `qrcode/v3/legacy/doc/<a>/<b>` included.
    // Addresses printed from now on: a document, an area, a section, an element or a unit section.
    {
        path: "qrcode/d/:docId",
        pathMatch: "full",
        data: ɵ0,
        loadChildren: ɵ1,
    },
    {
        path: "qrcode/a/:archiveId/:areaId",
        pathMatch: "full",
        data: ɵ2,
        loadChildren: ɵ3,
    },
    {
        path: "qrcode/s/:archiveId/:contentId",
        pathMatch: "full",
        data: ɵ4,
        loadChildren: ɵ5,
    },
    {
        path: "qrcode/s/:archiveId/:contentId/:elementId",
        pathMatch: "full",
        data: ɵ6,
        loadChildren: ɵ7,
    },
    // Stickers already printed, read through the new archive: reached from the legacy routes below
    // once `archiveV3Live` is on (PublicQrV3LegacyGuard).
    {
        path: "qrcode/v3/legacy/doc/:documentId/:subdocid",
        pathMatch: "full",
        data: ɵ8,
        loadChildren: ɵ9,
    },
    {
        path: "qrcode/v3/legacy/section/:documentId/:section",
        pathMatch: "full",
        data: ɵ10,
        loadChildren: ɵ11,
    },
    {
        path: "qrcode/v3/legacy/section/:documentId/:section/:subSection",
        pathMatch: "full",
        data: ɵ12,
        loadChildren: ɵ13,
    },
    {
        path: "qrcode/v3/legacy/section/:documentId/:section/:subSection/:structureId",
        pathMatch: "full",
        data: ɵ14,
        loadChildren: ɵ15,
    },
    {
        path: "qrcode/v3/legacy/sectionold/:propertyId/:sectionold",
        pathMatch: "full",
        data: ɵ16,
        loadChildren: ɵ17,
    },
    { path: "qrcode/:documentId/fireSafetyDoc", pathMatch: "prefix", component: PublicQRCodeComponent },
    { path: "qrcode/:documentId/genericDoc", pathMatch: "prefix", component: PublicQRCodeComponent },
    { path: "qrcode/:documentId/privacyStudioDoc", pathMatch: "prefix", component: PublicQRCodeComponent },
    { path: "qrcode/:propertyId/videoext", pathMatch: "prefix", component: PublicQRCodeComponent },
    { path: "qrcode/:propertyId/video", pathMatch: "prefix", component: PublicQRCodeComponent },
    { path: "qrcode/:companyId/safetyVideoSuppliers", pathMatch: "prefix", component: PublicQRCodeComponent },
    { path: "qrcode/:companyId/safetyVideoResidents", pathMatch: "prefix", component: PublicQRCodeComponent },
    { path: "qrcode/:propertyId/video/:token", pathMatch: "prefix", component: PublicQRCodeComponent },
    { path: "qrcode/:propertyId/docstructureext/:sectionold", pathMatch: "full", component: PublicQRCodeComponent, canActivate: [PublicQrV3LegacyGuard], data: ɵ18 },
    { path: "qrcode/:documentId/docstructure/:section", pathMatch: "full", component: PublicQRCodeComponent, canActivate: [PublicQrV3LegacyGuard], data: ɵ19 },
    { path: "qrcode/:documentId/docsubstructure/:section/:subSection/:structureId", pathMatch: "full", component: PublicQRCodeComponent, canActivate: [PublicQrV3LegacyGuard], data: ɵ20 },
    { path: "qrcode/:documentId/docsubstructure/:section/:subSection", pathMatch: "full", component: PublicQRCodeComponent, canActivate: [PublicQrV3LegacyGuard], data: ɵ21 },
    { path: "qrcode/:documentId/:doc/:type/:key/:subdocid", pathMatch: "full", component: PublicQRCodeComponent, canActivate: [PublicQrV3LegacyGuard], data: ɵ22 },
    { path: "qrcode-admin-mapping/:structureId", pathMatch: "full", component: AdminQRCodeMappingComponent },
    {
        path: "privacy-docs/:companyId/condo-owner",
        pathMatch: "full",
        component: PrivacyDocsPublicAccessComponent,
        data: ɵ23,
    },
    {
        path: "privacy-docs/:companyId/supplier",
        pathMatch: "full",
        component: PrivacyDocsPublicAccessComponent,
        data: ɵ24,
    },
    // Same as above, plus an optional trailing ":supplierId" segment (Angular
    // has no native syntax for an optional path param, so it's a second route
    // entry instead): when present, it scopes the "master" check/download
    // calls to that specific supplier (@see PrivacyDocsPublicAccessComponent)
    {
        path: "privacy-docs/:companyId/supplier/:supplierId",
        pathMatch: "full",
        component: PrivacyDocsPublicAccessComponent,
        data: ɵ25,
    },
    {
        path: ":lang",
        canActivate: [LangGuard],
        children: [
            {
                path: "auth",
                loadChildren: ɵ26,
            },
            {
                path: "app",
                component: AppWrapperComponent,
                canActivate: [AuthGuard],
                children: [
                    {
                        path: "",
                        pathMatch: "full",
                        component: HomeComponent,
                    },
                    {
                        path: "users",
                        loadChildren: ɵ27,
                    },
                    {
                        path: "temporaries",
                        loadChildren: ɵ28,
                    },
                    {
                        path: "permissions",
                        loadChildren: ɵ29,
                    },
                    {
                        path: "roles",
                        loadChildren: ɵ30,
                    },
                    {
                        path: "companies",
                        loadChildren: ɵ31,
                    },
                    {
                        path: "suppliers",
                        loadChildren: ɵ32,
                    },
                    {
                        path: "properties",
                        loadChildren: ɵ33,
                    },
                    {
                        path: "services",
                        loadChildren: ɵ34,
                    },
                    {
                        path: "prices",
                        loadChildren: ɵ35,
                    },
                    {
                        path: "subscriptions",
                        loadChildren: ɵ36,
                    },
                    {
                        path: "communications",
                        loadChildren: ɵ37,
                    },
                    {
                        path: "balances",
                        loadChildren: ɵ38,
                    },
                    {
                        path: "access-logs",
                        loadChildren: ɵ39,
                    },
                    {
                        path: "deadlines",
                        loadChildren: ɵ40,
                    },
                    {
                        path: "groundings",
                        loadChildren: ɵ41,
                    },
                    {
                        path: "caretakers",
                        loadChildren: ɵ42,
                    },
                    {
                        path: "summary-docs",
                        loadChildren: ɵ43,
                    },
                    {
                        path: "tank",
                        loadChildren: ɵ44,
                    },
                    {
                        path: "historical-docs",
                        loadChildren: ɵ45,
                    },
                    {
                        path: "search-docs",
                        loadChildren: ɵ46,
                    },
                    {
                        path: "add-documents",
                        loadChildren: ɵ47,
                    },
                    // Document insert on the 3.0.0 archive, for any property. Reachable by URL only until the
                    // cut-over moves the sidebar entry here from "add-documents"
                    {
                        path: "add-documentsV3",
                        loadChildren: ɵ48,
                    },
                    {
                        path: "ddts",
                        loadChildren: ɵ49,
                    },
                    {
                        path: "stats",
                        loadChildren: ɵ50,
                    },
                    {
                        path: "settings",
                        loadChildren: ɵ51,
                    },
                    {
                        path: "interventions",
                        loadChildren: ɵ52,
                    },
                    {
                        path: "electric-meters",
                        loadChildren: ɵ53,
                    },
                    {
                        path: "gas-meters",
                        loadChildren: ɵ54,
                    },
                    {
                        path: "water-meters",
                        loadChildren: ɵ55,
                    },
                    {
                        path: "personal-data",
                        loadChildren: ɵ56,
                    },
                    {
                        path: "generic-docs",
                        loadChildren: ɵ57,
                    },
                    {
                        path: "deleted-docs",
                        loadChildren: ɵ58,
                    },
                    {
                        path: "summary-docs-v3",
                        loadChildren: ɵ59,
                    },
                    {
                        path: "deleted-docs-v3",
                        loadChildren: ɵ60,
                    },
                    {
                        path: "deadlines-v3",
                        loadChildren: ɵ61,
                    },
                    {
                        path: "historical-docs-v3",
                        loadChildren: ɵ62,
                    },
                    // Arturo's pages: in the sidebar only with the arturoLive switch (@see arturo-switch.utils)
                    {
                        path: "arturo",
                        loadChildren: ɵ63,
                    },
                    {
                        path: "**",
                        redirectTo: "it/errors/404",
                    },
                ],
            },
            {
                path: "errors",
                loadChildren: ɵ64,
            },
            { path: "", pathMatch: "full", redirectTo: "auth/login" },
        ],
    },
    { path: "", redirectTo: "it", pathMatch: "full" },
    { path: "**", redirectTo: "it/errors/404" },
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17, ɵ18, ɵ19, ɵ20, ɵ21, ɵ22, ɵ23, ɵ24, ɵ25, ɵ26, ɵ27, ɵ28, ɵ29, ɵ30, ɵ31, ɵ32, ɵ33, ɵ34, ɵ35, ɵ36, ɵ37, ɵ38, ɵ39, ɵ40, ɵ41, ɵ42, ɵ43, ɵ44, ɵ45, ɵ46, ɵ47, ɵ48, ɵ49, ɵ50, ɵ51, ɵ52, ɵ53, ɵ54, ɵ55, ɵ56, ɵ57, ɵ58, ɵ59, ɵ60, ɵ61, ɵ62, ɵ63, ɵ64 };
